module.exports = __webpack_public_path__ + "img/guideline.c19d05d.svg";